import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MergeQuoteComponent } from './merge-quote/merge-quote.component'
import { MergeQuoteCardsComponent } from './merge-quote-cards/merge-quote-cards.component'
import { MergeQuoteProductsComponent } from './merge-quote-products/merge-quote-products.component'
import { MergeQuoteProductsListComponent } from './merge-quote-products-list/merge-quote-products-list.component'
import { MergeQuoteAcceptanceComponent } from './merge-quote-acceptance/merge-quote-acceptance.component'
import { DIALOG_TYPE, SpinnerModule } from '@spartacus/storefront'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { FormsModule } from '@angular/forms'
import { QuoteRejectDialogComponent } from './quote-merge/quote-reject-dialog/quote-reject-dialog.component'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MergeQuoteEditComponent } from './merge-quote-edit/merge-quote-edit.component'
import { AcceptQuoteDialogComponent } from './accept-quote-dialog/accept-quote-dialog.component'
import { StatusFilterPipe } from './merge-quote-products-list/status-filter.pipe'
import { ConfigModule, I18nModule, provideConfig } from '@spartacus/core'
import { ClickOutsideModule } from '../../../../shared/directive/clickOutside/click-outside.module'
import { environment } from '../../../../../environments/environment'
import { VS_LAUNCH_CALLER } from '../../../config/dialog.config'

@NgModule({
  declarations: [
    MergeQuoteComponent,
    MergeQuoteCardsComponent,
    MergeQuoteProductsComponent,
    MergeQuoteProductsListComponent,
    MergeQuoteAcceptanceComponent,
    QuoteRejectDialogComponent,
    MergeQuoteEditComponent,
    AcceptQuoteDialogComponent,
    StatusFilterPipe,
  ],
  imports: [
    CommonModule,
    SpinnerModule,
    MatCheckboxModule,
    FormsModule,
    ClickOutsideModule,
    MatTooltipModule,
    I18nModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['quoteTracking'],
        },
      },
    }),
  ],
  providers: [
    provideConfig({
      launch: {
        [VS_LAUNCH_CALLER.ACCEPT_QUOTE]: {
          inlineRoot: true,
          component: AcceptQuoteDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
        [VS_LAUNCH_CALLER.REJECT_QUOTE]: {
          inlineRoot: true,
          component: QuoteRejectDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
        [VS_LAUNCH_CALLER.MERGE_QUOTE_EDIT]: {
          inlineRoot: true,
          component: MergeQuoteEditComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
      },
    }),
  ],
})
export class QuoteMergeModule {}
